import Reveal from "./Reveal";
import SmartImg from "./SmartImg";
import useScrollProgress from "./useScrollProgress";

// =====================================================================
// TELAS DO APP (public/escape21/): troca os caminhos aqui se renomear.
// =====================================================================
const SCREENS = [
  { name: "Home", caption: "tudo que importa hoje, num lugar só", img: "/escape21/fotoapphome1.jpg" },
  { name: "Hábitos", caption: "tua sequência, visível todo dia", img: "/escape21/fotoapp-habits2.jpg" },
  { name: "Kore", caption: "teu assistente de IA dentro do app", img: "/escape21/fotoappkore3.jpg" },
  { name: "", caption: "e muitas outras funções no app", img: "/escape21/fotoappdemaisfuncoes4.jpg" },
];

/**
 * seção destaque (fundo escuro): fica "pinned" enquanto o usuário rola
 * e a tela dentro do mockup troca conforme o progresso do scroll.
 */
const AppShowcase = () => {
  const [sectionRef, progress] = useScrollProgress();

  const active = Math.min(SCREENS.length - 1, Math.floor(progress * SCREENS.length));
  // parallax leve: o mockup se move um pouco mais devagar que o resto
  const parallaxY = (0.5 - progress) * 28;

  return (
    <section ref={sectionRef} className="relative h-[380vh] bg-[#0A0A0A] text-white">
      {/* pb maior no mobile pra legenda não ficar atrás da barra de CTA fixa */}
      <div className="sticky top-0 flex h-svh flex-col items-center justify-center overflow-hidden px-6 pb-24 pt-8 md:py-10">
        <Reveal className="text-center">
          <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
            EscapeFlow · <span className="e21-serif normal-case">beta</span>
          </span>
          <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
            o desafio acontece dentro do app.
          </h2>
          <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/60 sm:text-base">
            marca teu check-in, acompanha tua sequência, e vê teu progresso do
            lado de quem também tá dentro.
          </p>
          <p className="mx-auto mt-3 max-w-md text-xs leading-relaxed text-white/40 sm:text-sm">
            o EscapeFlow tá em beta. ele melhora toda semana, e tu entra
            enquanto ele tá sendo construído. acesso antecipado de quem chegou
            primeiro.
          </p>
        </Reveal>

        {/* mockup de celular genérico em CSS (sem imagem de marca) */}
        <div
          className="mt-6 will-change-transform sm:mt-8"
          style={{ transform: `translateY(${parallaxY}px)` }}
        >
          {/* proporção casada com os prints reais (1289x2214) pra não cortar a UI */}
          <div className="relative aspect-[1289/2214] h-[min(462px,48svh)] rounded-[2.6rem] border-[7px] border-[#242424] bg-[#111] shadow-[0_30px_80px_rgba(0,0,0,0.6)] sm:h-[min(600px,58svh)]">
            {/* notch genérico */}
            <div className="absolute left-1/2 top-2.5 z-10 h-4 w-20 -translate-x-1/2 rounded-full bg-[#242424]" />
            <div className="absolute inset-0 overflow-hidden rounded-[2.2rem]">
              {SCREENS.map((screen, i) => (
                <div
                  key={screen.name}
                  className="absolute inset-0 transition-opacity duration-500"
                  style={{ opacity: i === active ? 1 : 0 }}
                >
                  <SmartImg
                    src={screen.img}
                    alt={`tela ${screen.name}`}
                    className="h-full w-full"
                    placeholder={
                      <div className="flex h-full w-full flex-col items-center justify-center gap-2 bg-[#161616]">
                        <span className="text-sm font-bold text-white/50">
                          {screen.name}
                        </span>
                        <span className="text-xs text-white/25">tela app aqui</span>
                      </div>
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* legenda sincronizada com a tela ativa (key remonta e anima) */}
        <p key={active} className="e21-tick mt-5 text-center text-sm sm:text-base">
          {SCREENS[active].name ? (
            <>
              <span className="font-bold">{SCREENS[active].name}</span>
              <span className="text-white/60"> → {SCREENS[active].caption}</span>
            </>
          ) : (
            <span className="e21-serif text-base text-white/80 sm:text-lg">
              {SCREENS[active].caption}
            </span>
          )}
        </p>

        {/* indicador de progresso */}
        <div className="mt-4 flex gap-1.5">
          {SCREENS.map((s, i) => (
            <span
              key={s.name}
              className={`h-1 rounded-full transition-all duration-300 ${
                i === active ? "w-6 bg-white" : "w-2.5 bg-white/25"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AppShowcase;
